<template>
  <div class="container">
    <van-sticky>
      <van-tabs v-model="tab" @change="getFistPageList">
        <!-- van-tab 不兼容用number类型 这里转换一下 -->
        <van-tab title="全部" :name="String(CouponStatusEnum.all)" />
        <van-tab title="未使用" :name="String(CouponStatusEnum.unused)" />
        <van-tab title="已使用" :name="String(CouponStatusEnum.used)" />
        <van-tab title="已过期" :name="String(CouponStatusEnum.expired)" />
      </van-tabs>
      <Activities />
    </van-sticky>
    <van-pull-refresh v-model="status.refreshing" @refresh="onRefresh">
      <van-list
        v-model="status.loading"
        :finished="status.finished"
        :finished-text="status.empty ? '' : '没有更多数据'"
        :error.sync="status.error"
        error-text="请求失败，点击重新加载"
        @load="getList"
      >
        <div class="list-body">
          <AdSwiper
            width="710"
            paddingBottom="20"
            code="my_platformcoupons_01_001"
            groupCode="my_platformcoupons_01"
            :refreshing="status.refreshing"
          />
          <coupons ref="coupons" :list="list" @refreshCoupon="onRefresh" />
          <template v-if="status.empty">
            <EmptyItem
              :url="$theme.u_general_icon_empty"
              title="暂无相关优惠券"
              info
            />
            <van-button class="go_btn" @click="onJumpToHome" type="primary">
              去逛逛
            </van-button>
          </template>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import http from '@/utils/axios';
import utils from '@/utils/common';
import { isWeChatApplet } from '@/utils/util';
import { CouponStatusEnum } from './utils/enum';
import EmptyItem from '@/views/shareDiscovery/components/emptyItem';
import AdSwiper from '@/components/ad/swiper';
import Activities from './components/activities';
import Coupons from './components/coupons';

export default {
  components: { Activities, Coupons, EmptyItem, AdSwiper },
  data() {
    const { subOrderId } = this.$route.query;
    return {
      subOrderId,
      CouponStatusEnum,
      tab: String(CouponStatusEnum.unused),
      page: {
        num: 1,
        size: 10
      },
      status: {
        error: false,
        refreshing: false,
        loading: false,
        finished: false,
        empty: false
      },
      list: []
    };
  },
  computed: {
    active() {
      return Number(this.tab);
    }
  },
  methods: {
    async onJumpToHome() {
      if (await isWeChatApplet()) {
        utils.goPageByName({ id: 'index', name: '首页' });
      } else {
        wx.miniProgram.switchTab({ url: '/pages/home/index' });
      }
    },
    async onJumpToLink() {
      if (await isWeChatApplet()) {
        utils.jumpToNewPage({ url: this.actlink });
      } else {
        location.href = this.actlink;
      }
    },
    async onJumpToActivityReceive() {
      if (await isWeChatApplet()) {
        //非小程序 app pc
        utils.jumpToNewPage({
          url: window.location.origin + "/h5user/activityReceive",
        });
      } else {
        //小程序
        let miniUrl = '/others/pages/navigate-webview/index?webtype=activityReceive'
        wx.miniProgram.navigateTo({ url: miniUrl })
      }
    },
    async goIndex() {
      if (await isWeChatApplet()) {
        utils.goPageByName({ id: "index", name: "首页" });
      } else {
        wx.miniProgram.switchTab({ url: "/pages/home/index" });
      }
    },
    onChange(tab) {
      console.log(tab, 444);
      this.active = tab;
      this.list = [];
      this.pageNum = 1;
      this.pageSize = 10;
      this.onLoad(tab);
    },
    onRefresh() {
      this.status.refreshing = true;
      setTimeout(this.getFistPageList, 1000);
    },
    getFistPageList() {
      this.page.num = 1;
      this.getList();
    },
    getList() {
      const { num, size } = this.page;
      const { all } = CouponStatusEnum;
      const parmes = {
        pageIndex: num,
        pageSize: size,
        isUsed: this.active === all ? undefined : this.active,
        subOrderId: this.subOrderId
      };
      const active = this.active;
      this.status.loading = true;
      http({
        url: 'order/coupon/getMyCoupon',
        method: 'post',
        parmes
      })
        .then((data) => {
          if (active !== this.active) return;
          this.status.error = false;
          this.status.loading = false;
          this.status.refreshing = false;
          this.$loading.hide();
          if (data.code === 200 && (data = data.data)) {
            if (parmes.pageIndex === 1) {
              this.$root.$el.scrollTop = 0;
              this.list.length = [];
            }
            this.list = this.list.concat(
              this.$refs.coupons.normalizeList(data.list)
            );
            this.status.finished = data.list.length < parmes.pageSize;
            this.status.empty = parmes.pageIndex === 1 && !data.list.length;
            this.page.num++;
          }
        })
        .catch(() => {
          if (active !== this.active) return;
          this.status.error = true;
          this.status.loading = false;
          this.status.refreshing = false;
          this.$loading.hide();
        });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-size: 28px;
  color: #333333;
}

// 保证除van-sticky的其它区域都可以下拉刷新
/deep/ .van-pull-refresh {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/deep/ .van-pull-refresh__track {
  flex: 1;
}

/deep/ .van-tabs__line {
  background-color: var(--buttonColor);
}

.list-body {
  padding: 20px 20px 0 20px;
}

.ad-swiper {
  padding-top: 20px;
}
.go_btn {
  width: 160px;
  height: 60px;
  background: var(--buttonColor);
  color: var(--textColor);
  border-radius: 32px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 33px;
  text-align: center;
  border: none;
  margin: 0 auto;
  display: block;
}
</style>
